// EXTERNAL DEPENDENCIES
import React from 'react'

// HELPERS
import { useBusinessProfilePageContent } from '../../hooks'
import { invokeOnSpaceOrEnter } from '@/utils'

// COMPONENTS
import {
  ArrowLeftIcon,
  BodyText,
  HeadingText,
  Link,
  Row,
} from '@paypalcorp/pp-react'

// STYLES
import styles from './styles.module.less'

/**
 * Header and back link shown at the top of pages
 */
export function PageHeaderSection({
  handleBackClick,
  pageHeaderText,
  subHeaderText,
  customBackLinkText,
  backLinkFpti = '',
}: {
  handleBackClick: () => void
  pageHeaderText: string
  subHeaderText?: string
  customBackLinkText?: string
  backLinkFpti?: string
}) {
  const getContent = useBusinessProfilePageContent()

  const backToBusinessProfileText = getContent('backToBusinessProfile')

  return (
    <Row noGutters className={styles.backButtonContainer}>
      <Link
        tabIndex={0}
        className={styles.backButton}
        onClick={handleBackClick}
        onKeyDown={invokeOnSpaceOrEnter(handleBackClick)}
        data-fpti={backLinkFpti}
      >
        <ArrowLeftIcon aria-hidden />
        {customBackLinkText || backToBusinessProfileText}
      </Link>
      <HeadingText level={1} className={styles.headerText}>
        {pageHeaderText}
      </HeadingText>
      {subHeaderText && <BodyText>{subHeaderText}</BodyText>}
    </Row>
  )
}
